(function (window, document, undefined) {
  'use strict';
  var ModalAlertCtrl = function ($uibModal, modalAlertSrvc, CONSTANTS) {
    modalAlertSrvc.resetService();

    modalAlertSrvc.promise.then(
      function () {},
      function () {},
      function (message) {
        // Apro la modale

        var ModalController = function ($scope, $modalInstance) {
          $scope.confirm = function () {
            $modalInstance.close();
          };
          $scope.cancel = function () {
            $modalInstance.dismiss();
          };
          $scope.message = message;
        };

        ModalController.$inject = ['$scope', '$modalInstance'];

        modalAlertSrvc.modal = $uibModal.open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'modalAlert/modalAlert.modal.html',
          size: 'md',
          controller: ModalController
        });
      }
    );
  };

  ModalAlertCtrl.$inject = ['$uibModal', 'modalAlertSrvc', 'FIN_CONSTANTS'];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'modalAlert/modalAlert.html'
    );
  };
  TemplateUrl.$inject = ['FIN_CONSTANTS'];

  var ModalAlertCmpt = {
    bindings: {},
    controller: ModalAlertCtrl,
    controllerAs: 'modalAlertCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.finanza.mf')
    .component('finanzaModalAlert', ModalAlertCmpt);
})(window, document);



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/modalAlert/modalAlert.cmpt.js
 ** module id = 44
 ** module chunks = 1 2
 **/